var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgriPixLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 166.74 48.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #3cb54a;\n      }\n\n      .cls-2 {\n        fill: #f68738;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.01,33.13h-10.11l-2.42,6.97h-3.92l8.91-24.82h4.95l8.91,24.82h-3.91l-2.42-6.97ZM69.94,30.06l-2.65-7.6-1.35-4.04-1.35,4.09-2.62,7.54h7.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.97,41.71h3.65c.27,1.64,1.92,2.6,4.07,2.6,2.78,0,4.29-1.66,4.29-4.41v-2.62c-1.03,1.92-2.94,2.79-5.11,2.79-4.57,0-7.53-3.77-7.53-9.11,0-5.66,3.27-9.43,7.63-9.43,2.53,0,4.27,1.28,5.11,3.13v-2.67h3.54v17.83c0,4.77-3.11,7.58-7.97,7.58-4.32,0-7.26-2.17-7.69-5.69ZM91.98,30.95v-.32c0-3.24-1.57-5.96-4.43-5.96s-4.48,2.85-4.48,6.23,1.53,6.14,4.45,6.14,4.47-2.9,4.47-6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.63,22h3.52v2.99c.92-2.19,2.51-3.36,4.61-3.36.57,0,1.16.07,1.55.2v3.42c-.46-.11-1.03-.2-1.6-.2-2.81,0-4.41,1.94-4.41,4.61v10.46h-3.67v-18.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.49,15.29h3.77v3.88h-3.77v-3.88ZM113.55,22h3.67v18.11h-3.67v-18.11Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122.3,15.29h9.73c4.57,0,7.85,2.99,7.85,7.31s-3.22,7.35-7.85,7.35h-5.96v10.16h-3.77V15.29ZM136.11,22.6c0-2.47-1.78-4.18-4.41-4.18h-5.62v8.4h5.62c2.65,0,4.41-1.76,4.41-4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143.41,22h3.67v18.11h-3.67v-18.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M156.31,30.87l-5.73-8.88h4.11l3.84,6.08,3.83-6.08h4.11l-5.73,8.88,6,9.23h-4.15l-4.06-6.42-4.07,6.42h-4.15l6-9.23Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.68,20.28c-6.1,7.56-4.82,33.81-33.94,26.43,18.39-2.21,21.9-16.23,23.76-26.83,3.42-.42,6.88-.32,10.18.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.58,6.93c-5.67,10.15,1.21,40.92-34.97,37.82l-2.08-.18C-3.67,24.29,17.57,6.07,37.58,6.93Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 23.32,
    cy: 24.76,
    r: 1.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1.45,45.12l-.91-.25c.05-.13,4.84-13.24,21.35-20l.4.75C6.15,32.23,1.49,44.99,1.45,45.12Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 21.98,
    y: 12.99,
    width: 4.13,
    height: 4.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 16.86,
    y: 16.11,
    width: 2.06,
    height: 2.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.82,
    y: 9,
    width: 1.49,
    height: 1.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 26.85,
    y: 17.14,
    width: 2.93,
    height: 2.93
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.31,
    y: 9.65,
    width: 1.96,
    height: 1.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.62,
    y: 5.16,
    width: 1.03,
    height: 1.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 22.3,
    y: 3.85,
    width: 1.18,
    height: 1.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.83,
    y: 1.76,
    width: 2.24,
    height: 2.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.34,
    y: 5.16,
    width: 2.93,
    height: 2.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 19.26,
    width: 1.94,
    height: 1.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M145.91,8.31c-.1-.19-.29-.31-.5-.31s-.41.12-.5.31l-.23.45c-.18.37-.22.43-.27.48-.05.05-.12.09-.48.27l-.45.23c-.19.1-.31.29-.31.5s.12.41.31.5l.45.23c.37.18.43.22.48.27.05.05.09.12.27.48l.23.45c.1.19.29.31.5.31s.41-.12.5-.31l.23-.45c.18-.37.22-.43.27-.48.05-.05.12-.09.48-.27l.45-.23c.19-.1.31-.29.31-.5s-.12-.41-.31-.5l-.45-.23c-.37-.18-.43-.22-.48-.27-.05-.05-.09-.12-.27-.48l-.23-.45ZM151.54,9.44c-.1-.19-.29-.31-.5-.31s-.41.12-.5.31l-.46.91c-.35.7-.47.93-.65,1.11-.18.18-.41.3-1.11.65l-.91.46c-.19.1-.31.29-.31.5s.12.41.31.5l.91.46c.7.35.93.47,1.11.65.18.18.3.41.65,1.11l.46.91c.1.19.29.31.5.31s.41-.12.5-.31l.46-.91c.35-.7.47-.93.65-1.11.18-.18.41-.3,1.11-.65l.91-.46c.19-.1.31-.29.31-.5s-.12-.41-.31-.5l-.91-.46c-.7-.35-.93-.47-1.11-.65-.18-.18-.3-.41-.65-1.11l-.46-.91ZM145.91,13.95c-.1-.19-.29-.31-.5-.31s-.41.12-.5.31l-.08.16c-.35.7-.47.93-.65,1.11-.18.18-.41.3-1.11.65l-.16.08c-.19.1-.31.29-.31.5s.12.41.31.5l.16.08c.7.35.93.47,1.11.65.18.18.3.41.65,1.11l.08.16c.1.19.29.31.5.31s.41-.12.5-.31l.08-.16c.35-.7.47-.93.65-1.11.18-.18.41-.3,1.11-.65l.16-.08c.19-.1.31-.29.31-.5s-.12-.41-.31-.5l-.16-.08c-.7-.35-.93-.47-1.11-.65-.18-.18-.3-.41-.65-1.11l-.08-.16Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgriPixLogo);
export default __webpack_public_path__ + "static/media/AgriPix_logo.a57ac3197a284b7a457aff6a81252b58.svg";
export { ForwardRef as ReactComponent };